export interface IActionType<A extends string, P> {
  type: A;
  payload: P;
}

export const actionCreator = <KType extends string, PType = undefined>(type: KType) => {
  type ActionCreatorArgsTuple = PType extends undefined ? [] : [PType];
  const creator = (...params: ActionCreatorArgsTuple): IActionType<KType, PType> => ({
    type,
    payload: params[0] as any,
  });

  creator.toString = () => type;

  return creator;
};

type DeepWriteable<T> = { -readonly [P in keyof T]: DeepWriteable<T[P]> };

export function makeWritable<T>(val: T): DeepWriteable<T> {
  return val;
}
